module.exports = __webpack_public_path__ + "img/f08d5de892e8d75a8243195e691f6a7c.8ae424ed.jpg";